import { ref } from 'vue';

export function useShuffleAnimation(
  initialValue: string | number = 0,
  shuffleDuration = 400,
) {
  const animatedValue = ref(String(initialValue));
  let animationFrameId: number | null = null;

  const generateRandomString = (length: number) => {
    const characters = '0123456789';
    let result = '';

    for (let i = 0; i < length; i++) {
      result += characters.charAt(
        Math.floor(Math.random() * characters.length),
      );
    }

    return result;
  };

  const animateShuffle = (finalValue: string) => {
    let startTime: number | null = null;
    const initialLength =
      animatedValue.value.length > 0
        ? animatedValue.value.length
        : String(initialValue).length;

    const step = (timestamp: number) => {
      if (!startTime) startTime = timestamp;

      const progress = timestamp - startTime;

      if (progress < shuffleDuration) {
        // Shuffle phase
        animatedValue.value = generateRandomString(
          finalValue.length > 0 ? finalValue.length : initialLength,
        );
        animationFrameId = window.requestAnimationFrame(step);
      } else {
        // Settle phase
        animatedValue.value = finalValue;
        if (animationFrameId) {
          window.cancelAnimationFrame(animationFrameId);
        }
      }
    };

    if (animationFrameId) {
      window.cancelAnimationFrame(animationFrameId);
    }
    animationFrameId = window.requestAnimationFrame(step);
  };

  const updateValue = (newValue: string | number) => {
    const finalValue = String(newValue);

    animateShuffle(finalValue);
  };

  // Initial value setup
  animatedValue.value = String(initialValue);

  return {
    animatedValue,
    updateValue,
  };
}
